import { iconFactory } from '../iconFactory'

export interface StarProps {
  fill?: string
  type?: 1 | 2 | 3 | 4 | 5 | 'empty' | 'default'
  outlined?: boolean
}

const getFill = (type: StarProps['type']): string => {
  switch (type) {
    case 'default':
      return 'currentColor'

    case 'empty':
      return '#CCCCCC'

    default:
      return `url(#star${type})`
  }
}

export const Star = iconFactory(
  'Star',
  ({ type = 'default', outlined = false }: StarProps) => (
    <>
      {!outlined ? (
        <path
          d="M13.9236 8.1955L10.8693 1L7.81505 8.20529L0 8.8694L5.93466 14.0106L4.15208 21.6517L10.8693 17.5964L17.5855 21.6517L15.8149 14.0106L21.7387 8.8694L13.9236 8.1955Z"
          fill={getFill(type)}
        />
      ) : (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9547 0.674072L7.90044 7.87936L0.0853882 8.54348L6.02005 13.6847L4.23748 21.3258L10.9547 17.2705L17.6709 21.3258L15.9003 13.6847L21.8241 8.54348L14.009 7.86958L10.9547 0.674072ZM7.95588 13.0532L4.34617 9.92279L9.10694 9.51085L10.9547 5.1305L12.8134 9.52172L17.5742 9.93475L13.9644 13.0651L15.0514 17.7172L10.9547 15.239L6.86894 17.7063L7.95588 13.0532Z"
          fill={getFill(type)}
        />
      )}

      {type !== 'default' && type !== 'empty' && (
        <defs>
          <linearGradient
            id="star1"
            x1="196.824"
            y1="11.1138"
            x2="2.25169"
            y2="-9.31522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ff8255" />
            <stop offset="63.15%" stopColor="#ff0082" />
            <stop offset="100%" stopColor="#c20098" />
          </linearGradient>
          <linearGradient
            id="star2"
            x1="153.024"
            y1="11.1138"
            x2="-41.5483"
            y2="-9.31522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ff8255" />
            <stop offset="63.15%" stopColor="#ff0082" />
            <stop offset="100%" stopColor="#c20098" />
          </linearGradient>
          <linearGradient
            id="star3"
            x1="109.324"
            y1="11.1138"
            x2="-85.2483"
            y2="-9.31522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ff8255" />
            <stop offset="63.15%" stopColor="#ff0082" />
            <stop offset="100%" stopColor="#c20098" />
          </linearGradient>
          <linearGradient
            id="star4"
            x1="65.6241"
            y1="11.1138"
            x2="-128.948"
            y2="-9.31522"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ff8255" />
            <stop offset="63.15%" stopColor="#ff0082" />
            <stop offset="100%" stopColor="#c20098" />
          </linearGradient>
          <linearGradient
            id="star5"
            x1="21.8241"
            y1="11.1138"
            x2="-172.748"
            y2="-9.31521"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#ff8255" />
            <stop offset="63.15%" stopColor="#ff0082" />
            <stop offset="100%" stopColor="#c20098" />
          </linearGradient>
        </defs>
      )}
    </>
  ),
  {
    viewBox: '0 0 22 22',
  },
)
